export default [
    {
        path: '/dashboard',
        name: 'DashboardPage',
        meta: { title: 'dashboard.listTitle', roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['dashboard'] },
        component: () => import('@/pages/dashboard/index.vue'),
    },
]